<template>
  <v-card flat>
    <v-row>
      <v-btn
        fab
        text
        @click="$emit('close')"
      >
        <v-icon>keyboard_backspace</v-icon>
      </v-btn>
      <p style="padding-top: 15px; font-size: 18px">
        Лицевой счёт: {{ customer.customer_number }}
      </p>
    </v-row>
    <v-card
      max-width="800"
      class="ma-3"
      flat
    >
      <v-select
        v-model="customer.customer_type"
        :items="customerTypes"
        item-text="customer_type_name"
        item-value="customer_type_id"
        label="Тип абонента"
        :disabled="customer.customer_id != null"
        required
      />
      <v-card-text v-if="customer.customer_type===1">
        <v-form ref="customerDetailsForm">
          <v-text-field
            v-model="customer.snils"
            v-snils
            label="Снилс"
            name="snils"
            :rules="[snilsValidate]"
          />
          <v-text-field
            v-model="customer.last_name"
            label="Фамилия"
            :rules="[rules.reguired]"
          />
          <v-text-field
            v-model="customer.first_name"
            label="Имя"
            :rules="[rules.reguired]"
          />
          <v-text-field
            v-model="customer.middle_name"
            label="Отчество"
            :rules="[rules.reguired]"
          />
        </v-form>
      </v-card-text>
      <v-card-text v-else-if="customer.customer_type===2">
        <v-form ref="customerDetailsForm">
          <v-text-field
            v-model="customer.company_inn"
            label="ИНН"
            :rules="[innValidate]"
            maxlength="12"
          />
          <v-text-field
            v-model="customer.company_ogrn"
            label="ОГРН"
            :rules="[rules.ogrn15]"
            maxlength="15"
          />
          <v-text-field
            v-model="customer.last_name"
            label="Фамилия"
            :rules="[rules.reguired]"
          />
          <v-text-field
            v-model="customer.first_name"
            label="Имя"
            :rules="[rules.reguired]"
          />
          <v-text-field
            v-model="customer.middle_name"
            label="Отчество"
            :rules="[rules.reguired]"
          />
        </v-form>
      </v-card-text>
      <v-card-text v-else-if="customer.customer_type===3">
        <v-form ref="customerDetailsForm">
          <v-text-field
            v-model="customer.company_inn"
            label="ИНН"
            :rules="[innValidate]"
            maxlength="10"
          />
          <v-text-field
            v-model="customer.company_kpp"
            label="КПП"
            :rules="[rules.kpp]"
            maxlength="9"
          />
          <v-text-field
            v-model="customer.company_ogrn"
            label="ОГРН"
            :rules="[rules.ogrn13]"
            maxlength="13"
          />
          <v-text-field
            v-model="customer.company_full_name"
            label="Название организации"
            :rules="[rules.reguired]"
          />
          <p>Представитель</p>
          <v-text-field
            v-model="customer.last_name"
            label="Фамилия"
            :rules="[rules.reguired]"
          />
          <v-text-field
            v-model="customer.first_name"
            label="Имя"
            :rules="[rules.reguired]"
          />
          <v-text-field
            v-model="customer.middle_name"
            label="Отчество"
            :rules="[rules.reguired]"
          />
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-btn @click="save">
          Сохранить
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-card>
</template>

<script>
export default {
  name: 'CustomerEdit',
  directives: {
    snils: {
      bind (el) {
        el.oninput = function (e) {
          const input = el.querySelector('input[name="snils"]')
          if (!e.isTrusted || !input) {
            return
          }

          const x = input.value.replace(/\D/g, '').match(/(\d{0,3})(\d{0,3})(\d{0,3})(\d{0,2})/)
          input.value =
              x[1] +
              (x[2] ? '-' + x[2] : '') +
              (x[3] ? '-' + x[3] : '') +
              (x[4] ? ' ' + x[4] : '')
          input.dispatchEvent(new Event('input'))
        }
      }
    }
  },
  props: {
    customerData: {}
  },
  data () {
    return {
      rules: {
        reguired: v => !!v || 'Заполните это поле!',
        ogrn13: v => v && v.match('^[0-9]{13}$') || 'ОГРН должен состоять из 13 цифр',
        ogrn15: v => v && v.match('^[0-9]{15}$') || 'ОГРН должен состоять из 15 цифр',
        kpp: v => v && v.match('^[0-9]{9}$') || 'КПП должен состоять из 9 цифр'
      },
      coeffs: {
        snils: [9, 8, 7, false, 6, 5, 4, false, 3, 2, 1],
        inn10: [2, 4, 10, 3, 5, 9, 4, 6, 8],
        inn11: [7, 2, 4, 10, 3, 5, 9, 4, 6, 8],
        inn12: [3, 7, 2, 4, 10, 3, 5, 9, 4, 6, 8]
      },
      localData: {},
      customerTypes: [
        { customer_type_id: 1, customer_type_name: 'Физическое лицо' },
        { customer_type_id: 2, customer_type_name: 'Индивидуальный предприниматель' },
        { customer_type_id: 3, customer_type_name: 'Юридическое лицо' }
      ],
      inputRules: [
        v => !!v || 'Заполните это поле!'
      ],
      customer: {}
    }
  },
  mounted () {
    this.customer = Object.assign({}, this.customerData)
  },
  methods: {
    save () {
      if (this.customer.customer_id != null) {
        this.axios.patch(`/api/customers/${this.customer.customer_id}/`, this.customer)
          .then(() => {
            this.$emit('edited', this.customer)
          })
          .catch((err) => {
            console.log(err)
            this.$emit('error')
          })
      } else {
        this.axios.post(`/api/customers/`, this.customer)
          .then((response) => {
            this.$emit('edited', response.data)
          })
          .catch((err) => {
            console.log(err)
            this.$emit('error')
          })
      }
    },
    snilsValidate (v) {
      if (!v || v.length !== 14) {
        return 'Снилс должен состоять из 11 цифр'
      }
      const checkSum = parseInt(v.slice(-2), 10)
      const sum = this.sumProduct(v, this.coeffs.snils) % 101 % 100
      if (sum !== checkSum) {
        return 'Снилс неверен - не совпадает контрольная сумма'
      }
      return true
    },
    innValidate (v) {
      const type = this.data.customer_type
      if (type !== 2 && type !== 3) {
        return 'Неверный тип абонента'
      }
      const [typePhrase, count] = {
        2: ['ИП', 12],
        3: ['Юр. лица', 10]
      }[type]
      if (!v || !v.match(`^[0-9]{${count}}$`)) {
        return `ИНН ${typePhrase} должен состоять из ${count} цифр`
      }
      if (type === 2) {
        const checkSum11 = parseInt(v[10])
        const checkSum12 = parseInt(v[11])
        const sum11 = this.sumProduct(v, this.coeffs.inn11) % 11 % 10
        const sum12 = this.sumProduct(v, this.coeffs.inn12) % 11 % 10
        if (sum11 !== checkSum11 || sum12 !== checkSum12) {
          return 'ИНН неверен - не совпадает контрольная сумма'
        }
      } else {
        const checkSum10 = parseInt(v[9])
        const sum10 = this.sumProduct(v, this.coeffs.inn10) % 11 % 10
        if (sum10 !== checkSum10) {
          return 'ИНН неверен - не совпадает контрольная сумма'
        }
      }
      return true
    },
    sumProduct (v, coeffs) {
      let sum = 0
      coeffs.forEach((coeff, i) => {
        sum += coeff ? coeff * v[i] : 0
      })
      return sum
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/spa/customers/CustomerEdit.vue